import module from 'empresa/module.js'
import template from './template.html'

export default class NominasSumarioAgregarConfirmarComponent {
  proyectoId
  nominaId
  data
  onClose
  placeholder
  resultado = {exito: false}
  procesando = false

  constructor ($state, NominasSumarioAgregar) {
    this.$state = $state
    this.NominasSumarioAgregarService = NominasSumarioAgregar
  }

  aceptar () {
    this.$state.go('nominas.detalladoNomina.informacion', {
      idEmpresa: this.resultado.data.id_proyecto,
      idNomina: this.resultado.data.id_nomina,
    }, {location: 'replace'})
  }

  guardar () {
    if (this.procesando) return

    this.procesando = true
    let data = {...this.data, notas: this.data.notas || this.placeholder}

    this.NominasSumarioAgregarService.post(this.proyectoId, data, this.nominaId)
      .then((response) => {
        this.resultado.data = response.data[0]
        this.resultado.exito = true
      })
      .catch((error) => (this.error = error.data))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: this.resultado}})
  }
}

module.component('nominasSumarioAgregarConfirmar', {
  controller: NominasSumarioAgregarConfirmarComponent,
  template,
  bindings: {
    proyectoId: '<',
    nominaId: '<',
    data: '<',
    placeholder: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/agregar/confirmar/component.js